import netteForms from 'nette-forms';

netteForms.initOnLoad();

import 'plugins/cookie-bar/cookie-bar-naja.js';
import SimpleLightbox from "simplelightbox";

$(document).ready(function () {
    window.app = new App();
    window.app.init();
});

function LoaderExtension(naja) {
    naja.addEventListener('init', function () {
        window.app = new App();
        window.app.init();
    }.bind(this));

    naja.addEventListener('complete', hideLoader.bind(this));
    naja.addEventListener('complete', hideLoader.bind(this));

    function hideLoader() {
        window.app.reload();
    }

    return this;
}

var App = function () {
    this.firstClick = true;
    this.enabledAuto = false;
};

App.prototype.init = function () {
    var self = this;

    naja.initialize();
    naja.addEventListener('complete', hideLoader.bind(this));

    function hideLoader() {
        window.app.reload();
    }

    self.reload();
    this.initWebStaff();

    new SimpleLightbox('.gallery-init a');
};

// App.prototype.initPagination = function () {
//     if ($('.pagination').length) {
//         //když .pagination a click tak animated scroll to .editor_content
//         $('.pagination a').click(function () {
//             $('html, body').animate({
//                 scrollTop: $('.breadcrumb').offset().top
//             }, 1000);
//         });
//     }
// };

App.prototype.initWebStaff = function () {
    // Event listener for episode_video click
    $('.episode_video').off('click').on('click',function () {
        const videoId = $(this).data('vdideo-id'); // Get the video ID from the clicked element
        const iframeUrl = `https://www.youtube.com/embed/${videoId}?si=H3or5QnrfmsA_-Fg`; // Construct the iframe URL
        $('.video_overlay iframe').attr('src', iframeUrl); // Set the iframe src attribute
        $('.video_overlay').fadeIn(); // Show the modal
    });

    // Close the modal when clicking on the close button
    $('.video_overlay__close').off('click').on('click',function () {
        $('.video_overlay').fadeOut(); // Hide the modal
        $('.video_overlay iframe').attr('src', ''); // Reset the iframe src to stop the video
    });

    // Close the modal when clicking outside the iframe
    $('.video_overlay').off('click').on('click',function (event) {
        if (!$(event.target).closest('iframe').length) { // Check if the click is outside the iframe
            $('.video_overlay').fadeOut(); // Hide the modal
            $('.video_overlay iframe').attr('src', ''); // Reset the iframe src to stop the video
        }
    });

};

App.prototype.reload = function () {
    // this.initPagination();
    this.paginatorFakeLink();
};

App.prototype.paginatorFakeLink = function () {
    var self = this;

    $('.paginatorFakeLink').off('click').on('click', function (e) {
        e.preventDefault();

        naja.makeRequest('POST', $(this).data('link'))
            .then(function (payload) {
                if (self.firstClick) {
                    self.autoPaginator();
                    self.firstClick = false;
                }
                self.enabledAuto = true;
                self.initWebStaff();
            })
            .catch(function (error) {
                console.log(error);
            });
    });
}

App.prototype.autoPaginator = function () {
    var self = this;
    var onAjax = false;
    $(window).scroll(function (event) {
        if ($('.paginatorFakeLink').length && $('.paginatorFakeLink').offset().top < $(window).scrollTop() + 2000 && self.enabledAuto) {
            if (!onAjax) {
                onAjax = true;

                naja.makeRequest('POST', $('.paginatorFakeLink').data('link'))
                    .then(function (payload) {
                        onAjax = false;
                        self.initWebStaff();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        }
    });
}
